import { useMemo } from 'react';

import { observer, useLocalObservable } from 'mobx-react-lite';

import { Button } from '@components/button';
import { IconOpen } from '@components/icons/open';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { Box } from 'components/Box';
import { DataTable } from 'components/DataTable';
import { configs } from 'jobboards/configs';
import { useStore } from 'models/Provider';

const RenderPrice = observer(({ item }) => {
  const { lang } = useStore();
  const config = configs[item.name];
  const texts = config[lang];
  return <span>{texts.priceText}</span>;
});

export const AvailableJobBoards = observer(({ boards, activate }) => {
  const { t } = useStore();
  const columns = useMemo(() => {
    return [
      {
        title: t('jobboards.table.jobboard'),
        render: (item) => <div>{configs[item.name].title}</div>,
      },
      { title: t('jobboards.table.price'), render: (item) => <RenderPrice item={item} /> },
      {
        title: t('jobboards.table.link'),
        render: (item) => {
          const link = configs[item.name].link;
          return (
            <Box flex alignItems="center">
              <IconOpen style={{ marginRight: '0.75rem' }} />
              <a href={'https://' + link} target="_blank" rel="noopener noreferrer">
                {link}
              </a>
            </Box>
          );
        },
      },
      {
        width: 0.5,
        style: { display: 'flex', justifyContent: 'flex-end' },
        render: (item) => <RenderConnectButton key={item.name} item={item} activate={activate} />,
      },
    ];
  }, [t, activate]);

  return (
    <Stack space={3}>
      <Text font="heading2" text={t('jobboards.settings.available')} />
      <DataTable
        spacing={false}
        columns={columns}
        data={boards}
        rowStyle={{ background: 'transparent' }}
      />
    </Stack>
  );
});

const RenderConnectButton = observer(({ item, activate }) => {
  const { t } = useStore();
  const state = useLocalObservable(() => ({
    submitting: false,
    setSubmitting(val) {
      state.submitting = val;
    },
    async submit() {
      state.setSubmitting(true);
      const success = await activate(item.name);
      if (!success) {
        state.setSubmitting(false);
      }
    },
  }));

  return (
    <>
      <Button
        isDisabled={state.submitting}
        onClick={state.submit}
        text={t('jobboards.settings.btn.connect')}
      />
    </>
  );
});
